import SiafLiteApiRepository from "../../external/siafLiteApi";

class TiposPessoasService {
  constructor() {
    this.urlBase = "/integracao/tipos-pessoas";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll() {
    return new SiafLiteApiRepository(this.urlBaseEvent).get();
  }
}

export default TiposPessoasService;
